var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"flatfinder-leaflet-v1-popper-card",attrs:{"value":_vm.value,"popper":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }